import { Helmet } from 'react-helmet-async';

const COSTCO_HOSTNAMES = ['costco.manageyourloans.com.au', 'costco.localhost'];

// Routes that are genuinely Costco-brand pages. Everything else canonicalises
// to MYL Direct, even when accessed via the costco subdomain — otherwise
// costco.manageyourloans.com.au/<any-MYL-path> ends up self-canonicalising and
// competes with the real MYL Direct URL in Google's index.
const COSTCO_EXACT_PATHS = new Set(['/costco', '/costco-terms']);
function isCostcoPath(path) {
  return COSTCO_EXACT_PATHS.has(path) || path.startsWith('/costco/');
}

function getSiteName() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (COSTCO_HOSTNAMES.some((h) => hostname === h)) {
      return 'Manage Your Loans — Costco Partner';
    }
  }
  return 'Manage Your Loans';
}

const SEO = ({ title, description, path = '', schema, noindex = false }) => {
  const siteName = getSiteName();
  const canonicalBase = isCostcoPath(path)
    ? 'https://costco.manageyourloans.com.au'
    : 'https://manageyourloans.com.au';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Award-Winning Mortgage Brokers`;
  const url = `${canonicalBase}${path}`;
  const ogImage = `${canonicalBase}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Geo */}
      <meta name="geo.region" content="AU" />
      <meta name="geo.country" content="AU" />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_AU" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {schema && (Array.isArray(schema)
        ? schema.map((s, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(s)}
            </script>
          ))
        : (
            <script type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          )
      )}
    </Helmet>
  );
};

export default SEO;
